
<style scoped>
    .company-top{width:100%;height:50vw;position:relative;cursor:pointer}
    .company-top .video-mask{position:absolute;left:0;bottom:0;width:100%;height:25vw;background-image:linear-gradient(0deg,rgba(0,0,0,.6),transparent);z-index:3;text-align:center;box-sizing:border-box;padding-top:9.5953125vw;padding-bottom:3.3541666667vw;color:#fff;font-size:.8786458333vw;font-weight:300}
    .company-top .video-mask .top{width:100%;display:flex;align-items:flex-start;justify-content:flex-start;padding:0 12.7776041667vw}
    .company-top .video-mask .top .logo-img{width:25.5557291667vw;height:5.2765625vw}
    .company-top .video-mask .top .slogan{width:45.8333333333vw;text-align:left;margin-left:2.7083333333vw;font-size:2.2223958333vw}
    .company-top .video-mask .top .slogan .title{font-family:Helvetica;font-size:2.2223958333vw;line-height:3.125vw}
    .company-top .video-mask .top .slogan .tips{font-family:Helvetica;font-size:.8786458333vw}
    .company-top .video-mask .line{width:82.9166666667vw;height:.0692708333vw;background-image:linear-gradient(270deg,hsla(0,0%,100%,0),#fff 51%,hsla(0,0%,100%,0));margin:1.9791666667vw auto}
    .company-top .video-mask .bottom{width:100%;text-align:center;margin-top:.5901041667vw}
    .company-top .video-mask .bottom .icons{width:28.2734375vw;height:1.7848958333vw}
    .company-line{width:100%;height:5.1109375vw;background-color:#fff}
    .company-scroll{width:100%;height:22.4875vw;overflow:hidden;position:relative}
    .company-scroll .scroll-box{width:100%;display:inline-flex;position:absolute;animation:scrollImage-data-v-74d6107e 25s linear infinite}
    .company-scroll .img{width:100%;height:100%}
    @keyframes scrollImage-data-v-74d6107e{0%{transform:translateX(0)}
    100%{transform:translateX(-100%)}
    }.company-introduce{width:100%;box-sizing:border-box;background-color:#fff;padding:0 6.1109375vw 3.6458333333vw}
    .company-introduce-info{font-family:SourceHanSansSC;padding-bottom:3.2291666667vw;box-sizing:border-box}
    .company-introduce-info .title{width:100%;font-weight:400;font-size:2.7776041667vw;color:#65c381;text-align:center;line-height:2.7776041667vw;margin-bottom:1.9442708333vw}
    .company-introduce-info .list{display:flex;align-items:center;justify-content:space-around}
    .company-introduce-info .list-item{font-weight:400;font-size:2.0833333333vw;color:#fff;line-height:3.0557291667vw;text-align:center;width:20.2776041667vw;height:3.0557291667vw;background:#19c780;border-radius:2.6041666667vw}
    .company-introduce-img,.company-introduce-img .left{display:flex;align-items:flex-start;justify-content:space-between}
    .company-introduce-img .left{height:100%;width:calc(100% - 22.2224vw);flex-wrap:wrap}
    .company-introduce-img,.company-introduce-img .left{display:flex;align-items:flex-start;justify-content:space-between}
    .company-introduce-img .img-box:first-child,.company-introduce-img .img-box:nth-child(2){margin-bottom:1.3890625vw}
    .company-introduce-img .img3{width:20.8333333333vw;height:43.0557291667vw}
    .company-introduce-img .img-box{overflow:hidden;position:relative;border-radius:.7291666667vw}
    .company-introduce-img .img{width:100%;height:100%;transition:transform .3s ease-in-out}
    .company-introduce-img .img-box .img-text{position:absolute;bottom:0;left:0;box-sizing:border-box;font-family:SourceHanSansSC;font-weight:500;padding-left:1.9442708333vw;font-size:1.1109375vw;color:#fff;text-align:left;line-height:4.4442708333vw;height:4.4442708333vw;width:100%;background-image:linear-gradient(0deg,rgba(0,0,0,.6),transparent);border-radius:0 0 .6942708333vw .6942708333vw}
    .company-introduce-img .img-box:first-child,.company-introduce-img .img-box:nth-child(2){margin-bottom:1.3890625vw}
    .company-introduce-img .img1{width:20.8333333333vw;height:20.8333333333vw}
    .company-introduce-img .img{width:100%;height:100%;transition:transform .3s ease-in-out}
    .company-introduce-img .img-box .img-text .big{font-size:2.0833333333vw}
    .company-introduce-img .img-box:first-child,.company-introduce-img .img-box:nth-child(2){margin-bottom:1.3890625vw}
    .company-introduce-img .img2{width:43.3333333333vw;height:20.8333333333vw}
    .company-introduce-img .img-box:first-child,.company-introduce-img .img-box:nth-child(2){margin-bottom:1.3890625vw}
    .company-introduce-img .img3{width:20.8333333333vw;height:43.0557291667vw}
    .company-introduce-img .img:hover{transform:scale(1.05)}
</style>

<template>
    <div class="company page">
        <div class="company-top">
            <video autoplay="" loop="loop" muted="muted" width="100%" class="video" style="object-fit: fill;">
                <source src="https://crm-cdn.sd.zhumanggroup.com/2024-10-09/7b3ab4208fd8c34afd8c3c7cd1387c51.mov" type="video/mp4">
                Xin lỗi, trình duyệt của bạn không hỗ trợ video nhúng. Đừng lo, bạn có thể
                <a href="https://crm-cdn.sd.zhumanggroup.com/2024-10-09/7b3ab4208fd8c34afd8c3c7cd1387c51.mov">tải về</a>
                và xem bằng trình phát yêu thích!
            </video>
            <div class="video-mask">
                <div class="top">
                    <img src="/img/logo.bb7994b.png" class="logo-img">
                    <div class="slogan">
                        <div class="title">Nhà sản xuất và vận hành hạ tầng thông minh cho các kịch bản công cộng</div>
                        <div class="tips">Sở hữu các thương hiệu như Jiedian, Soudian, tự xây dựng công viên công nghệ 100.000m², tự nghiên cứu và sản xuất các sản phẩm sạc, bán lẻ, tủ lưu trữ, máy lọc nước, robot, v.v.,
            cung cấp giải pháp nhu cầu tức thì cho người dùng toàn cầu trong các kịch bản công cộng.
                        </div>
                    </div>
                </div>
                <div class="line"></div>
                <div class="bottom"><img src="/img/icons.24603c7.png" class="icons"></div>
            </div>
        </div>
        <div class="company-line"></div>
        <div class="company-scroll">
            <div class="scroll-box">
                <img src="/img/scroll.1814f8f.png" class="img">
                <img src="/img/scroll.1814f8f.png" class="img">
            </div>
        </div>
        <div class="company-introduce">
            <div class="company-introduce-info">
                <div class="title">
                    Ba lĩnh vực chính
                </div>
                <div class="list">
                    <div class="list-item">
                        Xây dựng năng lượng
                    </div>
                    <div class="list-item">
                        Hạ tầng bán lẻ
                    </div>
                    <div class="list-item">
                        Nghiên cứu phát triển robot
                    </div>
                </div>
            </div>
            <div class="company-introduce-img">
                <div class="left">
                    <div class="img-box img1">
                        <img src="/img/company1.6d3ea9e.png" class="img">
                        <div class="img-text">
                            Người dùng
                            <span class="big">
                                Hơn 500 triệu
                            </span>
                        </div>
                    </div>
                    <div class="img-box img2">
                        <img src="/img/company2.b4be3dc.png" class="img">
                        <div class="img-text">
                            Bán chạy tại
                            <span class="big">
                                30+
                            </span>
                            quốc gia và khu vực
                        </div>
                    </div>
                    <div class="img-box img1">
                        <img src="/img/company3.ac1b988.png" class="img">
                        <div class="img-text">
                            Top 100 chất lượng Thâm Quyến
                        </div>
                    </div>
                    <div class="img-box img2">
                        <img src="/img/company4.ddaba11.png" class="img">
                        <div class="img-text">
                            Top 500 thương hiệu châu Á
                        </div>
                    </div>
                </div>
                <div class="img-box img3">
                    <img src="/img/company5.c65a531.png" class="img">
                    <div class="img-text">
                        Dự án quốc gia thương hiệu mạnh
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  mounted() {
  // 给导航高亮
  const path = window.location.pathname;
  const menu = document.querySelector('.menu');
  if (menu) {
    const menuItems = menu.querySelectorAll('.menu-item');
    menuItems.forEach(item => {
      const linkDiv = item.querySelector('.menu-item-link');
      const aTag = linkDiv ? linkDiv.querySelector('a') : null;
      if (linkDiv && aTag) {
        if (aTag.getAttribute('href') === path) {
          linkDiv.classList.add('active-route');
        } else {
          linkDiv.classList.remove('active-route');
        }
      }
    });
  }
  
},
}
</script>